export const enum OfferType {
  Instant = 'instant',
  Contracted = 'contracted',
  ShipperDirect = 'shipper-direct',
}

export function getOfferType(isContracted: boolean, isLoadCandidate: boolean): OfferType {
  if (isContracted) return OfferType.Contracted
  if (isLoadCandidate) return OfferType.ShipperDirect
  return OfferType.Instant
}
